import { supabase } from '../../supabase'

export default class SupabaseStorageService {
  async uploadProfileImage(file: File, userId: string): Promise<string> {
    const path = `profiles/${userId}/${Date.now()}_${this.sanitizeFileName(file.name)}`

    const { error } = await supabase.storage.from('relentless-assets').upload(path, file, {
      upsert: true,
    })
    if (error) throw error

    // Generate and return the public URL of the uploaded image
    const {
      data: { publicUrl: publicURL },
    } = supabase.storage.from('relentless-assets').getPublicUrl(path)

    return publicURL
  }

  async uploadMessageImage(file: File, userId: string, messageId: string): Promise<string> {
    const timestamp = Date.now()
    const path = `messages/${userId}/${messageId}/${timestamp}_${this.sanitizeFileName(file.name)}`

    const { error } = await supabase.storage.from('relentless-assets').upload(path, file, {
      upsert: false, // Don't overwrite, each image should be unique
    })
    if (error) throw error

    // Generate and return the public URL of the uploaded image
    const {
      data: { publicUrl: publicURL },
    } = supabase.storage.from('relentless-assets').getPublicUrl(path)

    return publicURL
  }

  async uploadGateSubmissionMedia(
    file: File,
    userId: string,
    gateId: string,
    submissionId: string,
  ): Promise<string> {
    const timestamp = Date.now()
    const path = `gates/${gateId}/${userId}/${submissionId}/${timestamp}_${this.sanitizeFileName(file.name)}`

    const { error } = await supabase.storage.from('relentless-assets').upload(path, file, {
      upsert: true,
    })
    if (error) throw error

    const {
      data: { publicUrl: publicURL },
    } = supabase.storage.from('relentless-assets').getPublicUrl(path)

    return publicURL
  }

  sanitizeFileName(fileName: string): string {
    return fileName.replace(/[^a-zA-Z0-9.]/g, '_')
  }
}
